import axios from "axios";

const doesSupportsGroupCollapsed = String(console.groupCollapsed).includes(
  "code",
);

export function errorLogger(error: any) {
  // Do not log cancelled errors
  if (axios.isCancel(error)) throw error;

  if (!axios.isAxiosError(error)) {
    throw error;
  }

  const { request, response, config, message } = error;

  if (!response) {
    console.log(
      `\n
🔴 Network error | ${error.config?.method?.toUpperCase()} ${error.config?.url}
No response received from server`,
    );
  } else {
    console.log(`\n
Network error | ${error.config?.method?.toUpperCase()} ${error.config?.url}

ꜱᴛᴀᴛᴜꜱ
${response.status} ${response.statusText || ""}

ʀᴇQᴜᴇꜱᴛ ᴅᴀᴛᴀ
${
  config?.data == null
    ? "none"
    : JSON.stringify(
        (() => {
          try {
            return JSON.parse(config.data);
          } catch {
            return String(config.data);
          }
        })(),
        null,
        2,
      )
        .replace(/^/gm, "> ")
        .replace(/^(.{120}).*$/gm, "$1...")
}

ʀᴇꜱᴩᴏɴꜱᴇ ᴅᴀᴛᴀ
${
  response.data
    ? JSON.stringify(response.data, null, 2).replace(/^/gm, "< ")
    : "none"
}

ʀᴇQᴜᴇꜱᴛ ʜᴇᴀᴅᴇʀꜱ
${
  config?.headers
    ? JSON.stringify(config.headers, null, 2).replace(/^/gm, "> ")
    : "none"
}

ʀᴇꜱᴩᴏɴꜱᴇ ʜᴇᴀᴅᴇʀꜱ
${JSON.stringify(response.headers, null, 2).replace(/^/gm, "< ")}

`);
  }

  if (doesSupportsGroupCollapsed) {
    console.groupCollapsed("Advanced info");
    console.log("Error:", {
      request,
      response,
      config,
      message,
    });
    console.groupEnd();
  }

  throw error;
}
